import { FC } from "react";
import cx from "classnames";
import styles from "./vehicle-year.module.scss";

interface IVehicleYear {
  year: string | number;
  className?: string;
}

const VehicleYear: FC<IVehicleYear> = ({ year, className }) => (
  <span className={cx(styles.container, className)}>{year}</span>
);

export default VehicleYear;
